import { Label } from '@facephi/ui-react';
import { useTranslation } from 'react-i18next';
import { devicesMock } from '../../../api';
import { DEVICES_COLORS, StackedBar } from '../graph';
import { CardBaseHeaderStyled, DevicesCard } from './Styles';

export const Devices = () => {
  const { t } = useTranslation();

  const devicesData = devicesMock;

  return (
    <DevicesCard>
      <CardBaseHeaderStyled noBorder small>
        <Label fontSize="21" semibold>
          {t('Devices')}
        </Label>
      </CardBaseHeaderStyled>
      <StackedBar
        {...devicesData}
        showLegend={false}
        colors={DEVICES_COLORS}
        style={{ height: '100%', width: '100%' }}
      />
    </DevicesCard>
  );
};
